module.exports = __webpack_public_path__ + "img/h_hearts.75b70f11.png";